<div class="d-flex justify-content-between align-items-center w-100">

    <div class="d-flex align-items-center gap-3">
        <app-page-header Heading="Notification History" Description="">
        </app-page-header>

        <app-pagination 
            [EnablePageSize]="true" 
            [rowData]="notifHistoryData"
            (pageSizeChanged)="handlePageSizeChange($event)">
        </app-pagination>
    </div>

    <div class="d-flex align-items-center gap-2">
        </div>

</div>

<div class="row ">
    <div class="card px-0 mb-0">
        <div class="card-body py-2 px-1 ">
            <div class="d-flex flex-row align-items-center gap-2 filter-row w-100" id="filterContainer">
                <!-- Filter Icon -->
                <div class="d-flex align-items-center px-1 filter-icon">
                    <i class="fa-solid fa-filter fa-lg text-secondary"></i>
                </div>

                <!-- From Date -->
                <div class="d-flex flex-column justify-content-start">
                    <div class="d-flex align-items-center date-input">
                        <label for="startDate" class="form-label mb-0 me-2 d-flex align-items-center">
                            <i class="fa-regular  me-1"></i> From
                        </label>
                        <input type="date" id="startDate" class="form-control form-control-sm"
                            [formControl]="dateForm.controls.startDate">
                    </div>
                    <div>
                        <app-form-errors [control]="dateForm.controls.startDate"
                            fieldName="Start Date"></app-form-errors>
                    </div>
                </div>




                <!-- To Date -->
                <div class="d-flex flex-column justify-content-start">

                    <div class="d-flex align-items-center date-input">
                        <label for="endDate" class="form-label mb-0 me-2 d-flex align-items-center">
                            <i class="fa-solid  me-1"></i> To
                        </label>
                        <input type="date" id="endDate" class="form-control form-control-sm"
                            [formControl]="dateForm.controls.endDate" />
                    </div>
                    <div>
                        <app-form-errors [control]="dateForm.controls.endDate" fieldName="End Date"></app-form-errors>
                    </div>
                </div>



                <!-- Search Input -->
                <div class="d-flex align-items-center w-25 search-input">
                    <input type="search" id="usearch" class="form-control form-control-sm"
                        placeholder="Search by Subject,Remark,Email to .."
                        [formControl]="dateForm.controls.whereClause" />
                </div>
                <div class="d-flex align-items-center">
                    <button class="btn btn-primary btn-sm" (click)="loadDataByDate()" [disabled]="isLoading">Load Data</button>
                </div>

                <div class="d-flex align-items-center">
                    <button class="btn btn-sm btn-secondary mx-1" (click)="clearSearchAndReload()" [disabled]="isLoading">Clear</button>
                </div>
                <div class="d-flex align-items-center">
                    <button class="btn btn-primary btn-sm mx-1" (click)="BulkEdit()" *ngIf="editFlag">Edit
                        Status</button>
                    <div *ngIf="popupVisible" class="modal-overlay"></div>
                    <div *ngIf="popupVisible" class="inline-form shadow-lg bg-white rounded-3 border"
                        style="width:400px; z-index:1050; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                        [formGroup]="NotificationHistoryForm">
                        <div
                            class="form-header border-bottom px-3 py-2 d-flex justify-content-between align-items-center">
                            <span class="fw-semibold fs-5 text-primary">Edit Status</span>
                            <i class="bi bi-x-lg text-muted" style="cursor:pointer;" (click)="popupVisible = false"></i>
                        </div>
                        <div class="p-3">
                            <div class="mb-2">
                                <label class="form-label small fw-medium text-secondary mb-1 text-start d-block">
                                    Status<span class="text-danger">*</span>
                                </label>

                                <select class="form-control form-control-sm shadow-none"
                                    [formControl]="NotificationHistoryForm.controls.nStatus">
                                    <option value="" disabled hidden>Select status</option>
                                    <option *ngFor="let status of statusOptions" [value]="status">{{ status }}</option>
                                </select>

                                <!-- Error message -->
                                <app-form-errors [control]="NotificationHistoryForm.controls.nStatus"
                                    fieldName="Status">
                                </app-form-errors>

                            </div>

                            <div class="mb-2">
                                <label
                                    class="form-label small fw-medium text-secondary mb-1 text-start d-block">Remarks<span
                                        class="text-danger">*</span></label>

                                <textarea class="form-control form-control-sm shadow-none" placeholder="Enter remarks"
                                    [formControl]="NotificationHistoryForm.controls.remarks">
                                </textarea>

                                <!-- Error message -->
                                <app-form-errors [control]="NotificationHistoryForm.controls.remarks"
                                    fieldName="Remarks">
                                </app-form-errors>


                            </div>
                            <div class="d-flex justify-content-end gap-2 mt-2">
                                <button class="btn btn-outline-secondary btn-sm px-3"
                                    (click)="popupVisible = false">Cancel</button>
                                <button class="btn btn-primary btn-sm px-3" (click)="onSubmitAction()">Add</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <ng-container *ngIf="isLoading; else notificationHistoryTableContent">
        <div class="card mb-1">
            <div class="card-header d-flex align-items-center">
                <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
                <span class="ml-2">
                    <ngx-skeleton-loader count="1" width="150px" height="16px"></ngx-skeleton-loader>
                </span>
            </div>
            <div class="card-body">
                <ngx-skeleton-loader count="3" width="100%" height="14px"
                    style="margin-bottom: 8px;"></ngx-skeleton-loader>
            </div>
        </div>
    </ng-container>

    <ng-template #notificationHistoryTableContent>
        <div class="card">
            <div class="card-header">
                <h5 class="mb-0 text-primary">Notification History</h5>
            </div>

            <div style="overflow-x: auto;">
                <table class="table table-bordered table-hover" style="table-layout: fixed; min-width: 1200px;">
                    <thead class="table-light">
                        <tr>
                            <th style="width: 50px;">

                                <input type="checkbox" [checked]="areAllSelectableRowsSelected()"
                                    (change)="toggleAll($event)" />

                            </th>
                            <th style="width: 80px;">SrNo.</th>
                            <th style="width: 150px;">NType</th>
                            <th style="width: 200px;">NSubject</th>
                            <th style="width: 300px;">NContent</th>
                            <th style="width: 150px;">NTo</th>
                            <th style="width: 150px;">NCc</th>
                            <th style="width: 150px;">NBcc</th>
                            <th style="width: 100px;">NStatus</th>
                            <th style="width: 200px;">Remarks</th>
                            <th style="width: 150px;">ScheduledDate</th>
                            <th style="width: 200px;">AttachmentPath</th>
                            <th style="width: 100px;">RetryCount</th>
                            <th style="width: 150px;">RetryDate</th>
                            <th style="width: 200px;">PostSendDataSourceType</th>
                            <th style="width: 300px;">PostSendDataSourceDef</th>
                            <th style="width: 100px;">DbConnId</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let row of notifHistoryData; let i = index">
                            <td>
                                <input type="checkbox" [checked]="selectedIndexes.includes(i)"
                                    (change)="toggleSelection(i)" *ngIf="row.nStatus !== 'Success';" />
                            </td>

                            <!-- <td>{{ i + 1 }}</td> -->
                            <td>{{ row.rowNum }}</td>
                            <td> <span [ngbTooltip]="row.nType">{{ row.nType }}</span></td>
                            <td> <span [ngbTooltip]="row.nTo">{{ row.nSubject }}</span></td>
                            <!-- <td><span class="ellipsis-text" [ngbTooltip]="row.nContent">{{row.nContent }}</span> -->
                            <td>
                                <span [ngbTooltip]="tooltipContent" [tooltipClass]="'custom-tooltip'"
                                    class="ellipsis-text">
                                    {{ row.nContent }}
                                </span>

                                <ng-template #tooltipContent>
                                    <div class="tooltip-ellipsis">
                                        {{ row.nContent }}
                                    </div>
                                </ng-template>




                            </td>

                            <td> <span [ngbTooltip]="row.nTo">{{ row.nTo }}</span></td>
                            <!-- <td> <span [ngbTooltip]="row.nCc">{{ row.nCc }}</span></td> -->
                            <td>
                                <span [ngbTooltip]="tooltipContent2" [tooltipClass]="'custom-tooltip'"
                                    class="ellipsis-text">
                                    {{ row.nCc }}
                                </span>

                                <ng-template #tooltipContent2>
                                    <div class="tooltip-ellipsis">
                                        {{ row.nCc }}
                                    </div>
                                </ng-template>
                            </td>
                            <!-- <td><span [ngbTooltip]="row.nBcc">{{ row.nBcc }}</span></td> -->
                            <td>
                                <span [ngbTooltip]="tooltipContent" [tooltipClass]="'custom-tooltip'"
                                    class="ellipsis-text">
                                    {{ row.nBcc }}
                                </span>

                                <ng-template #tooltipContent>
                                    <div class="tooltip-ellipsis">
                                        {{ row.nBcc }}
                                    </div>
                                </ng-template>
                            </td>
                            <td>
                                <!-- show/edit status for this row -->
                                <ng-container
                                    *ngIf="!row.statusEdit || row.nStatus ==='Success'; else editStatusTemplate">
                                    {{ row.nStatus }}
                                    <i *ngIf="row.nStatus !=='Success'" class="bi bi-pencil-fill"
                                        style="cursor:pointer; float: right;" (click)="row.statusEdit = true"></i>
                                </ng-container>

                                <ng-template #editStatusTemplate>
                                    <select [(ngModel)]="row.nStatus" (change)="onStatusChange(row)">
                                        <option *ngFor="let status of statusOptions" [value]="status">{{ status }}
                                        </option>
                                    </select>
                                    <i class="bi bi-x-circle-fill" (click)="row.statusEdit = false"
                                        style="cursor:pointer; margin-left: 5px;"></i>
                                </ng-template>

                            </td>

                            <td>
                                <ng-container
                                    *ngIf="!row.remarksEdit  || row.nStatus ==='Success'; else editRemarksTemplate">
                                    {{ row.remarks }}
                                    <i *ngIf="row.nStatus!=='Success'" class="bi bi-pencil-fill"
                                        style="cursor: pointer; float: right;" (click)="enableRemarksEdit(row)"></i>
                                </ng-container>
                                <ng-template #editRemarksTemplate>
                                    <input type="text" [(ngModel)]="row.remarks"
                                        class="form-control form-control-sm d-inline-block w-40"
                                        style="max-width: 200px;" />
                                    <i class="bi bi-check-circle-fill text-success ms-2" style="cursor: pointer;"
                                        (click)="onStatusChange(row)"></i>
                                    <i class="bi bi-x-circle-fill text-danger ms-2" style="cursor: pointer;"
                                        (click)="cancelRemark(row)"></i>
                                </ng-template>
                            </td>

                            <td>{{ row.scheduledDate | date:'medium' }}</td>
                            <td><span [ngbTooltip]="row.attachmentPath">{{ row.attachmentPath }}</span></td>
                            <td><span *ngIf="row.retryCount != null" [ngbTooltip]="row.retryCount.toString()">{{
                                    row.retryCount }}</span></td>
                            <td>{{ row.retryDate | date:'medium'}}</td>
                            <td><span [ngbTooltip]="row.postSendDataSourceDef">{{ row.postSendDataSourceType }}</span>
                            </td>
                            <td style="white-space: pre-wrap; word-break: break-word;"> <span
                                    [ngbTooltip]="row.attachmentPath"></span>
                                {{ row.postSendDataSourceDef }}
                            </td>
                            <td><span [ngbTooltip]="row.postSendDataSourceDef">{{ row.dbConnId }}</span></td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </ng-template>


    <app-pagination [EnableNavigation]="true" [rowData]="notifHistoryData"
        (pageSizeChanged)="handlePageSizeChange($event)">
    </app-pagination>